import { ORDER_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import HighlightActions from '../HighlightCard/HighlightActions';
import { jsx as _jsx } from "react/jsx-runtime";
const OrderHighlightActions = ({
  objectId
}) => {
  return /*#__PURE__*/_jsx(HighlightActions, {
    objectId: objectId,
    objectTypeId: ORDER_TYPE_ID
  });
};
export default OrderHighlightActions;